import { Injectable } from "@angular/core";
import {
    ActivatedRouteSnapshot,
    Resolve,
    RouterStateSnapshot,
} from "@angular/router";
import { Location } from "@angular/common";
import { HttpResponse } from "@angular/common/http";
import { BehaviorSubject, Observable } from "rxjs";
import { OrderAuthorization, PageOptions, ApiGateway } from "cw-backend";
import { CwUtils } from "cw-utils";

@Injectable()
export class DbDiagnosticProvider {
    orderAuthorization: OrderAuthorization[];
    orderAuthorizationEdit: OrderAuthorization;
    onDataChanged: BehaviorSubject<any>;
    routeParams: any;
    state: any;
    path = "integration";

    constructor(
        public gw: ApiGateway,
        private location: Location,
    ) {
        this.onDataChanged = new BehaviorSubject({});
    }

    getProcedureByOrder(orderId: number, tableName: string): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw
                .get(
                    `${this.path}/procedure/orderId/${orderId}?tableName=${tableName}`,
                )
                .subscribe({
                    next: (response) => resolve(response),
                    error: (err) => reject(err),
                });
        });
    }

    receivesCare(orderItemDBList): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw
                .post(
                    `${this.path}/db-diagnostic/receivesCare`,
                    orderItemDBList,
                )
                .subscribe({
                    next: (response) => resolve(response),
                    error: (err) => reject(err),
                });
        });
    }

    receivesCareLabchekap(orderItemDBList): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw
                .post(`${this.path}/labchekap/receivesCare`, orderItemDBList)
                .subscribe({
                    next: (response) => resolve(response),
                    error: (err) => reject(err),
                });
        });
    }


    receivesCareLabAlvaro(orderItemDBList): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw
                .post(`${this.path}/lab-alvaro/receivesCare`, orderItemDBList)
                .subscribe({
                    next: (response) => resolve(response),
                    error: (err) => reject(err),
                });
        });
    }


    checkStatus(orderId: number): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw
                .get(`${this.path}/db-diagnostic/status/${orderId}`)
                .subscribe({
                    next: (response) => resolve(response),
                    error: (err) => reject(err),
                });
        });
        
    }

       checkStatusLabcheckap(orderId: number): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw
                .get(`${this.path}/labchekap/status/${orderId}`)
                .subscribe({
                    next: (response) => resolve(response),
                    error: (err) => reject(err),
                });
        });
    }

    checkStatusLabAlvaro(orderId: number): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw
                .get(`${this.path}/lab-alvaro/status/${orderId}`)
                .subscribe({
                    next: (response) => resolve(response),
                    error: (err) => reject(err),
                });
        });
    }

    getResult(orderId: number): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw
                .get(`${this.path}/db-diagnostic/result/${orderId}`)
                .subscribe({
                    next: (response) => resolve(response),
                    error: (err) => reject(err),
                });
        });
    }

    getResultLabchekap(orderId: number): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.get(`${this.path}/labchekap/result/${orderId}`).subscribe({
                next: (response) => resolve(response),
                error: (err) => reject(err),
            });
        });
    }

    getResultLabAlvaro(orderId: number): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.get(`${this.path}/lab-alvaro/result/${orderId}`).subscribe({
                next: (response) => resolve(response),
                error: (err) => reject(err),
            });
        });
    }
}
